const {
  REACT_APP_API_PROXY_URL,
  REACT_APP_OKTA_CLIENT_ID,
  REACT_APP_OKTA_URL,
  NODE_ENV,
  REACT_APP_TERMS_LAST_UPDATE = '2001-01-01T00:00:00.000Z',

  // development environment variables
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_SAMPLE_RATE,
  REACT_APP_LOGIN_SPLASH_MESSAGE,
  REACT_APP_USE_CUSTOM_LOGIN,
  REACT_APP_ISSUER_ROOT
} = process.env

const isDev = NODE_ENV === 'development'
const isProd = NODE_ENV === 'production'
const isTest = NODE_ENV === 'test'

const config = {
  env: {
    isDev,
    isProd,
    isTest
  },
  oktaAuthConfig: {
    issuer: `${REACT_APP_OKTA_URL}/oauth2/default`,
    clientId: REACT_APP_OKTA_CLIENT_ID,
    redirectUri: `${window.location.origin}/login/callback`
  },
  sentry: {
    dsn: REACT_APP_SENTRY_DSN,
    envName: NODE_ENV,
    tracesSampleRate: REACT_APP_SENTRY_SAMPLE_RATE || '1.0'
  },
  apiProxyUrl: REACT_APP_API_PROXY_URL || '/api',
  loginSplashMessage: REACT_APP_LOGIN_SPLASH_MESSAGE,
  termsLastUpdateDate: REACT_APP_TERMS_LAST_UPDATE,
  useCustomLogin: REACT_APP_USE_CUSTOM_LOGIN === '1',
  issuerRoot: REACT_APP_ISSUER_ROOT
}

export default config
